import { Component } from 'react';
import { Button } from 'reactstrap';

import PropTypes from 'prop-types';
import BackendApiService from '../../services/BackendApiService';
import TransferenceApproveRepresentationModal from '../approve-representation-modal/TransferenceApproveRepresentationModal';
import { app } from '../../config';

// D3: any unreadable answer means "show the confirmation". Never fail open.
function requiresRepresentationConfirmation(result) {
  if (!result || typeof result.is_representation === 'undefined') return true;
  return Boolean(result.is_representation);
}

class TransferenceApproveButton extends Component {
  constructor(props) {
    super(props);
    this.handleAprobarClick = this.handleAprobarClick.bind(this);
    this.doApprove = this.doApprove.bind(this);
    this.state = {
      checking: false,
      approving: false,
      showModal: false,
    };
  }

  handleAprobarClick() {
    if (!app.enableApproveRepresentationModal) {
      this.doApprove();
      return;
    }

    this.setState({ checking: true });
    BackendApiService.getTransferenceRepresentation(this.props.code)
      .then((result) => {
        this.setState({ checking: false });
        if (requiresRepresentationConfirmation(result)) {
          this.setState({ showModal: true });
        } else {
          this.doApprove();
        }
      })
      .catch((error) => {
        console.error(error);
        this.setState({ checking: false, showModal: true });
      });
  }

  doApprove() {
    this.setState({ approving: true });
    BackendApiService.approveTransference(this.props.code)
      .then(() => {
        window.location.reload();
      })
      .catch((error) => {
        alert('error aprobando transferencia');
        console.error(error);
      })
      .finally(() => this.setState({ approving: false }));
  }

  render() {
    return (
      <>
        <Button disabled={this.state.checking || this.state.approving} onClick={this.handleAprobarClick} color="success">
          {(this.state.checking || this.state.approving) ? 'Aprobando...' : 'Aprobar'}
        </Button>
        {app.enableApproveRepresentationModal && (
          <TransferenceApproveRepresentationModal
            isOpen={this.state.showModal}
            patente={this.props.patente}
            loading={this.state.approving}
            onConfirm={this.doApprove}
            onCancel={() => this.setState({ showModal: false })}
          />
        )}
      </>
    );
  }
}

TransferenceApproveButton.propTypes = {
  code: PropTypes.string,
  patente: PropTypes.string,
};

export default TransferenceApproveButton;
